import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const witnessSlide = createSlice({
    name: "witness",
    initialState: {
        page: 0,
        pageCount: 0,
        total: 0,
        success: false,
        fail: false,
        listData: null,
        detailData: null,
        responseData: null,
        errorDetailData: null,
        actionSuccess: false,
    },
    reducers: {
        doGetWitnessListSuccess: (state, action) => {
            state.listData = action.payload.data;
            state.page = action.payload.current_page;
            state.pageCount = action.payload.page_count;
            state.total = action.payload.total_row;
        },
        doGetWitnessListFail: (state) => {
            state.listData = null;
            state.page = 0;
            state.pageCount = 0;
            state.total = 0;
        },
        doGetWitnessDetailSuccess: (state, action) => {
            state.detailData = action.payload.witness;
        },
        doGetWitnessDetailFail: (state) => {
            state.detailData = null;
        },
        doAddWitnessSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
            state.responseData = action.payload;
        },
        doAddWitnessFail: (state, action) => {
            state.success = false;
            state.fail = true;
            state.errorDetailData = action.payload;
        },
        doUpdateWitnessSuccess: (state) => {
            state.success = true;
            state.fail = false;
        },
        doUpdateWitnessFail: (state, action) => {
            state.success = false;
            state.fail = true;
            state.errorDetailData = action.payload;
        },
        doWitnessActionSuccess: (state) => {
            state.actionSuccess = true;
        },
        doWitnessActionFail: (state, action) => {
            state.actionSuccess = false;
            state.errorDetailData = action.payload;
        },
        resetWitnessStateSuccess: (state, action) => {
            state.success = action.payload;
            state.fail = action.payload;
            state.detailData = null;
            state.errorDetailData = null;
            state.actionSuccess = false;
        },
    },
});

export const doGetWitnessList = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/witnesses?page=${param.page}&size=${param.limit}`;
        if (param.keyword) {
            url += `&keyword=${encodeURIComponent(param.keyword)}`;
        }
        const response = await axios.get(url);
        dispatch(doGetWitnessListSuccess(response.data));
    } catch (error) {
        dispatch(doGetWitnessListFail(error.response));
    }
};

export const doGetWitnessDetail = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/witnesses/${param.witness_id}`;
        const response = await axios.get(url);
        dispatch(doGetWitnessDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetWitnessDetailFail(error.response));
    }
};

export const doAddWitness = (formData) => async (dispatch) => {
    try {
        const url = `/api/admin/witnesses`;
        const response = await axios.post(url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        dispatch(doAddWitnessSuccess(response.data));
    } catch (error) {
        dispatch(doAddWitnessFail(error.response));
    }
};

export const doUpdateWitness = (formData, witnessId) => async (dispatch) => {
    try {
        const url = `/api/admin/witnesses/${witnessId}`;
        const response = await axios.put(url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        dispatch(doUpdateWitnessSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateWitnessFail(error.response));
    }
};

export const doSetDefaultWitness = (witnessId, isDefault) => async (dispatch) => {
    try {
        const url = `/api/admin/witnesses/${witnessId}/default`;
        const response = await axios.patch(url, { is_default: isDefault });
        dispatch(doWitnessActionSuccess(response.data));
    } catch (error) {
        dispatch(doWitnessActionFail(error.response));
    }
};

export const doDeleteWitness = (witnessId) => async (dispatch) => {
    try {
        const url = `/api/admin/witnesses/${witnessId}`;
        const response = await axios.delete(url);
        dispatch(doWitnessActionSuccess(response.data));
    } catch (error) {
        dispatch(doWitnessActionFail(error.response));
    }
};

export const resetWitnessState = () => async (dispatch) => {
    dispatch(resetWitnessStateSuccess(false));
};

export const {
    doGetWitnessListSuccess,
    doGetWitnessListFail,
    doGetWitnessDetailSuccess,
    doGetWitnessDetailFail,
    doAddWitnessSuccess,
    doAddWitnessFail,
    doUpdateWitnessSuccess,
    doUpdateWitnessFail,
    doWitnessActionSuccess,
    doWitnessActionFail,
    resetWitnessStateSuccess,
} = witnessSlide.actions;

export const getWitnessList = (state) => state.witness?.listData;
export const getWitnessListPage = (state) => state.witness?.page;
export const getWitnessListPageCount = (state) => state.witness?.pageCount;
export const getWitnessListTotal = (state) => state.witness?.total;
export const getWitnessDetail = (state) => state.witness?.detailData;
export const getWitnessErrorDetailData = (state) => state.witness?.errorDetailData;
export const getAddWitnessSuccess = (state) => state.witness?.success;
export const getAddWitnessFail = (state) => state.witness?.fail;
export const getAddWitnessResponseData = (state) => state.witness?.responseData;
export const getWitnessActionSuccess = (state) => state.witness?.actionSuccess;

export default witnessSlide.reducer;
